(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gs-bestsellers"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('gs-bestsellers')) {
    customElements.define(
      'gs-bestsellers',
      class extends HTMLElement {
        connectedCallback() {
          this.tabs = [...this.querySelectorAll('[role="tab"]')];
          this.panels = [...this.querySelectorAll('[role="tabpanel"]')];

          this.tabs.forEach((tab, i) => tab.addEventListener('click', () => this.select(i)));
          this.querySelector('[data-prev]')?.addEventListener('click', () => this.scroll(-1));
          this.querySelector('[data-next]')?.addEventListener('click', () => this.scroll(1));
          this.addEventListener('click', (e) => {
            const btn = e.target.closest('[data-add]');
            if (btn && !btn.disabled) this.add(btn);
          });

          /* En el editor: al seleccionar una pestaña, mostrarla */
          document.addEventListener('shopify:block:select', (e) => {
            const i = this.tabs.indexOf(e.target);
            if (i > -1) this.select(i);
          });
        }

        select(i) {
          this.tabs.forEach((t, k) => t.setAttribute('aria-selected', String(k === i)));
          this.panels.forEach((p, k) => (p.hidden = k !== i));
        }

        scroll(dir) {
          const track = this.panels.find((p) => !p.hidden)?.querySelector('.gs-best__track');
          if (track) track.scrollBy({ left: dir * track.clientWidth, behavior: 'smooth' });
        }

        /* Agrega al carrito y abre la bolsa lateral del tema */
        async add(btn) {
          const error = this.querySelector('.gs-best__error');
          const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
          const body = { items: [{ id: +btn.dataset.add, quantity: 1 }] };
          if (cart?.getSectionsToRender) {
            body.sections = cart.getSectionsToRender().map((s) => s.id);
            body.sections_url = window.location.pathname;
          }
          btn.classList.add('is-loading');
          btn.disabled = true;
          error.hidden = true;
          try {
            const res = await fetch(`${window.routes?.cart_add_url || '/cart/add'}.js`, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify(body),
            }).then((r) => r.json());

            if (res.status) {
              error.textContent = res.description || res.message;
              error.hidden = false;
              return;
            }
            if (!cart || !res.sections) {
              window.location = window.routes?.cart_url || '/cart';
              return;
            }
            cart.getSectionsToRender().forEach((section) => {
              const target = document.getElementById(section.id);
              const html = new DOMParser().parseFromString(res.sections[section.id] || '', 'text/html');
              const source = html.querySelector('#minicart-form');
              if (target && source) target.innerHTML = source.innerHTML;
            });
            cart.cartAction?.();
            cart.classList.remove('is-empty');
            cart.open?.();

            const fresh = await fetch(`${window.routes?.cart_url || '/cart'}.js`).then((r) => r.json());
            document.querySelectorAll('.cart-count').forEach((el) => {
              el.textContent = el.classList.contains('cart-count-drawer')
                ? `(${fresh.item_count})`
                : fresh.item_count > 100 ? '~' : fresh.item_count;
            });
            document.querySelector('free-ship-progress-bar')?.init?.(fresh.items_subtotal_price);
            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'gs-bestsellers', cartData: res });
            }
          } catch (e) {
            error.textContent = window.cartStrings?.error || 'No se pudo agregar. Inténtalo de nuevo.';
            error.hidden = false;
          } finally {
            btn.classList.remove('is-loading');
            btn.disabled = false;
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gs-shop-the-look"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('gs-shop-the-look')) {
    customElements.define(
      'gs-shop-the-look',
      class extends HTMLElement {
        connectedCallback() {
          this.rows = [...this.querySelectorAll('[data-item]')].map((row) => ({
            row,
            index: +row.dataset.item,
            variants: JSON.parse(row.querySelector('[data-variants]').textContent),
            piece: this.querySelector(`[data-piece="${row.dataset.item}"]`),
          }));

          this.addEventListener('change', (e) => {
            const row = e.target.closest('[data-item]');
            if (row && e.target.matches('[data-option]')) this.syncImage(this.rows.find((r) => r.row === row));
            this.render();
          });
          this.querySelectorAll('[data-hot]').forEach((hot) => hot.addEventListener('click', () => this.focusItem(+hot.dataset.hot)));
          this.querySelector('[data-add]').addEventListener('click', () => this.add());
          if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
              if (event?.source !== 'gs-shop-the-look') this.refreshCart();
            });
          }
          this.rows.forEach((r) => this.syncImage(r));
          this.render();
        }
        disconnectedCallback() {
          this.unsubscribe?.();
        }

        money(cents) {
          const format = window.themeGlobalVariables?.settings?.money_format;
          if (window.Shopify?.formatMoney && format) return Shopify.formatMoney(cents, format);
          return 'S/ ' + (cents / 100).toFixed(2);
        }

        /* Variante exacta según los selectores de la fila (o la única si no hay opciones) */
        variantOf(r) {
          const selects = [...r.row.querySelectorAll('[data-option]')];
          if (!selects.length) return r.variants[0];
          const chosen = selects.map((s) => s.value);
          return r.variants.find((v) => v.options.every((o, i) => o === chosen[i]));
        }

        /* Cambia la foto de la prenda (lienzo + miniatura) a la del color elegido */
        syncImage(r) {
          const v = this.variantOf(r);
          if (!v) return;
          const swap = (img, src) => {
            if (!img || !src || img.getAttribute('src') === src) return;
            img.classList.add('is-loading');
            img.removeAttribute('srcset');
            img.removeAttribute('sizes');
            img.onload = () => img.classList.remove('is-loading');
            img.src = src;
          };
          swap(r.piece?.querySelector('.gs-look__piece-img'), v.image);
          swap(r.row.querySelector('.gs-look__thumb-img'), v.thumb);
        }

        focusItem(i) {
          this.querySelectorAll('[data-hot]').forEach((h) => h.setAttribute('aria-pressed', String(+h.dataset.hot === i)));
          this.rows.forEach((r) => r.row.classList.toggle('is-active', r.index === i));
          this.rows.find((r) => r.index === i)?.row.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }

        chosen() {
          return this.rows
            .map((r) => {
              const box = r.row.querySelector('.gs-look__check');
              const v = this.variantOf(r);
              const ok = !!v && v.available;
              const status = r.row.querySelector('[data-status]');
              status.hidden = ok;
              status.textContent = ok ? '' : this.dataset.soldout;
              if (v) r.row.querySelector('[data-line-price]').textContent = this.money(v.price);
              const on = box.checked && !box.disabled;
              r.piece?.classList.toggle('is-off', !on);
              return { on: on && ok, id: v?.id, price: v?.price || 0 };
            })
            .filter((x) => x.on);
        }

        render() {
          const chosen = this.chosen();
          const total = chosen.reduce((a, x) => a + x.price, 0);
          this.querySelector('[data-total]').textContent = this.money(total);
          const btn = this.querySelector('[data-add]');
          btn.disabled = !chosen.length;
          btn.textContent = chosen.length ? this.dataset.button.replace('[count]', chosen.length) : this.dataset.empty;

          const ship = this.querySelector('[data-ship]');
          const threshold = +this.dataset.threshold;
          const missing = threshold - (+this.dataset.cart + total);
          const text = missing <= 0 ? this.dataset.shipDone : this.dataset.shipProgress.replace('[amount]', this.money(missing));
          ship.hidden = !threshold || !chosen.length || !text;
          ship.classList.toggle('is-done', missing <= 0);
          ship.textContent = text;
        }

        refreshCart() {
          fetch(`${window.routes?.cart_url || '/cart'}.js`)
            .then((r) => r.json())
            .then((cart) => {
              this.dataset.cart = cart.items_subtotal_price;
              this.render();
            })
            .catch(() => {});
        }

        async add() {
          const btn = this.querySelector('[data-add]');
          const error = this.querySelector('[data-error]');
          const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
          const items = this.chosen().map((x) => ({ id: x.id, quantity: 1 }));
          if (!items.length) return;
          const body = { items };
          if (cart?.getSectionsToRender) {
            body.sections = cart.getSectionsToRender().map((s) => s.id);
            body.sections_url = window.location.pathname;
          }
          btn.disabled = true;
          error.hidden = true;
          try {
            const res = await fetch(`${window.routes?.cart_add_url || '/cart/add'}.js`, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify(body),
            }).then((r) => r.json());

            if (res.status) {
              error.textContent = res.description || res.message;
              error.hidden = false;
              return;
            }
            if (!cart || !res.sections) {
              window.location = window.routes?.cart_url || '/cart';
              return;
            }
            cart.getSectionsToRender().forEach((section) => {
              const target = document.getElementById(section.id);
              const html = new DOMParser().parseFromString(res.sections[section.id] || '', 'text/html');
              const source = html.querySelector('#minicart-form');
              if (target && source) target.innerHTML = source.innerHTML;
            });
            cart.cartAction?.();
            cart.classList.remove('is-empty');
            cart.open?.();

            const fresh = await fetch(`${window.routes?.cart_url || '/cart'}.js`).then((r) => r.json());
            this.dataset.cart = fresh.items_subtotal_price;
            document.querySelectorAll('.cart-count').forEach((el) => {
              el.textContent = el.classList.contains('cart-count-drawer')
                ? `(${fresh.item_count})`
                : fresh.item_count > 100 ? '~' : fresh.item_count;
            });
            document.querySelector('free-ship-progress-bar')?.init?.(fresh.items_subtotal_price);
            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'gs-shop-the-look', cartData: res });
            }
          } catch (e) {
            error.textContent = window.cartStrings?.error || 'No se pudo agregar. Inténtalo de nuevo.';
            error.hidden = false;
          } finally {
            this.render();
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["top-bar"] && !Shopify.designMode) return;
  try {
    
  let top_bar = document.querySelector('.section-top-bar')?.clientHeight || 0;
  const body = document.querySelector('body');
  body.style.setProperty('--height-topbar', `${top_bar}px`);

  } catch(e) { console.error(e); }
})();
})();
